import React from 'react';
import FlexBox from '@bexs/dollar/components/Flex';
import Typography from '@bexs/dollar/components/Typography';
import { SvgCapital } from '@bexs/dollar-icons';
import { useSelector } from 'store';
import { formatCurrency } from 'utils/intl';
import {
  SummaryCard,
  CurrencyIndicator,
} from 'pages/Balance/sections/Summary/styles';
import { colors } from 'styles/colors/raw';

const Summary: React.FC = () => {
  const { error, balanceLast, isLoading, lastUpdated } =
    useSelector().statements;

  return (
    <SummaryCard
      title="Overview"
      style={{
        marginTop: '32px',
      }}
    >
      <FlexBox direction="row" alignContent="flex-start" alignItems="center">
        <SvgCapital size="92px" color={colors['primary/1000']} />
        {error ? (
          '...'
        ) : (
          <FlexBox direction="column" style={{ marginLeft: '16px' }}>
            <Typography
              as="p"
              color="#6F6F6F"
              size="14px"
              style={{ margin: 0, color: '#6F6F6F' }}
            >
              Total account balance
            </Typography>
            <FlexBox direction="row" alignItems="center">
              <Typography
                data-testid="total-value"
                as="p"
                variation="h4"
                size="36px"
                weight={400}
                style={{ margin: '4px 0 8px 0' }}
              >
                {isLoading ? '...' : formatCurrency(balanceLast)}
              </Typography>
              <CurrencyIndicator as="p" weight={400}>
                BRL
              </CurrencyIndicator>
            </FlexBox>
            <Typography
              as="p"
              size="12px"
              style={{ margin: 0, color: '#6F6F6F' }}
            >
              {isLoading ? '' : `Updated on ${lastUpdated}`}
            </Typography>
          </FlexBox>
        )}
      </FlexBox>
    </SummaryCard>
  );
};

export default Summary;
